import styled from 'styled-components';
import { FlexCenter } from '@app.styled';
import Link from '@components/Link/Link';

export const PromotionCard = styled(FlexCenter)`
    background-color: ${({ theme }) => theme.colors.whiteSmoke};
    flex-direction: column;
`;

export const Content = styled.div`
    display: flex;
    margin: 1.375rem 0 1.375rem 0;
    padding: 0 1.25rem;
    gap: 15px;

    span {
        align-self: center;
    }

    button:hover {
        background: ${({ theme: { colors } }) => colors.darkCyanBlue};
    }

    @media screen and (max-width: 768px) {
        text-align: center;
        flex-wrap: wrap;
        justify-content: center;
    }
`;

export const AvailableContent = styled.div`
    display: flex;
    background-color: ${({ theme }) => theme.colors.navyBlue};
    color: ${({ theme }) => theme.colors.white};
    width: 100%;
    justify-content: center;
    padding: 0.875rem 0;

    h3 {
        margin-bottom: 0;
    }
    img {
        width: 1.5rem;
        height: 1.5rem;
        align-self: center;
        margin-left: 20px;
        margin-right: 8px;
    }
    @media screen and (max-width: 425px) {
        align-items: center;
    }
`;
export const AppStore = styled(Link)`
    display: flex;
    cursor: pointer;
    color: inherit;
    text-decoration: none;

    :hover {
        color: #fcfcfc;
    }
`;

export const PromoTitle = styled.div`
    color: #222a34;
    font-size: 24px;
    letter-spacing: 0;
    line-height: 32px;
`;
